export default {"src":"/_next/static/media/og-thumbnail.1b88a3e0.gif","height":630,"width":1200,"blurWidth":0,"blurHeight":0};